import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';
import classNames from "classnames";
import { loginAxios } from '../../../config/axios.config';
import * as Yup from "yup";
import { ErrorMessage, Field, FieldArray, Form, Formik, } from "formik";
import { FormGroup, Label, Button, Spinner } from "reactstrap";
import Content from "../../../layout/content/Content";
import {
    Icon,
    RSelect,
    Row,
    Col,

    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Block,
} from "../../../components/Component";

import { useMutation, useQuery } from "@tanstack/react-query";
// import { getPidDetails, savePidDetails } from "../../../redux"; 
import { useParams, useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
const InvoiceAdd = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const { invoiceID } = useParams();
    const [isEdit, setIsEdit] = useState(typeof invoiceID !== "undefined" ? true : false);

    const [poArray, setPoArray] = useState([]);

    var purchaseTypeList = [
        { value: 'Consignment', label: 'Consignment' },
        { value: 'Outright', label: 'Outright' },
    ];

    const [formValues, setFormValues] = useState([{
        id: '',
        invoice_file_url: '',
        po_values: '',
        po_number: '',
        invoice_number: '',
        invoice_amount: '',
    }]); 

    const saveFile = async (params) => {
        try {
            const { data } = await loginAxios.post(`designers/upload-document`, params.formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const saveFileCall = useMutation(saveFile);




    const saveInvoice = async (params) => {
        try {
            const { data } = await loginAxios.post(`designers/invoice/upsert_invoice?is_edit=${isEdit}`, params, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const saveInvoiceCall = useMutation(saveInvoice);



    const poList = async (param) => {
        try {
            const { data } = await loginAxios.get(`designers/invoice/get_designer_po_list`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };


    const poListCall = useMutation(poList, {
        onSettled(data, error) {
            if (data) {
                let tempArr = data?.data?.po_collection?.map((item, i) => {
                    return {
                        label: item,
                        value: item
                    }
                })
                setPoArray(tempArr);
            } else if (error) {
                console.log(error);
            }
        }
    })




    const getPODetails = async (param) => {
        try {
            const { data } = await loginAxios.get(`designers/invoice/get_invoice_details?id=${param.id}`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const getPODetailsCall = useMutation(getPODetails);

    useEffect(() => {
        poListCall.mutate();
    }, []);


    useEffect(() => {
        console.log(isEdit)
        if (isEdit) {
            let payload = {
                id: invoiceID
            }
            getPODetailsCall.mutate(payload, {
                onSettled(data, error) {
                    if (data) {
                        console.log(data?.data);

                        console.log(data?.data?.po_number);

                        let tempData = JSON.parse(JSON.stringify(data?.data));

                        console.log(tempData?.po_number)

                        let po_number_arr = new Array();

                        po_number_arr = tempData?.po_number?.split(",");
                        let temp_po_number = tempData?.po_number?.split(",");
                        // let po_number_arr = tempData?.po_number?.split(',');


                        console.log(po_number_arr);
                        console.log(typeof po_number_arr);

                        let po_number_values = po_number_arr?.map((item, i) => {
                            return {
                                label: item,
                                value: item
                            }
                        })
                        // console.log(po_number_values)

                        tempData.po_values = po_number_values;
                        tempData.po_number = temp_po_number;

                        console.log(tempData)
                        // setFormValues([data?.data])
                        setFormValues([tempData]);

                    } else if (error) {
                        console.log(error);
                    }
                }
            });
        };
    }, []);

    const handleFileSave = (e, item, index) => {
        let formData = new FormData();

        let maxSize = 5;
        const file = e.target.files[0];
        if (((file.size / 1024) / 1000) < maxSize) {

            formData.append("file", file);
            formData.append("doc_type", 'designer_invoice');
            var payload = {
                formData                
            }
            saveFileCall.mutate(payload, {
                onSettled(data, error) {
                    if (data) {
                        let tempData = JSON.parse(JSON.stringify(formValues));
                        tempData[index].invoice_file_url = data?.data?.file_path;
                        setFormValues(tempData);
                    } else if (error) { }
                }
            });
        } else {
            toast.info("Please upload file less than 5 MB", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                progress: false,
            });
        }

    }

    const handlePONumber = (e, item, index) => {
        let tempData = JSON.parse(JSON.stringify(formValues));
        let poNos = e.map((item, i) => item.value);
        tempData[index].po_values = e;
        tempData[index].po_number = poNos;
        setFormValues(tempData);
    }

    const handleInvoiceChange = (e, item, index) => {
        let tempData = JSON.parse(JSON.stringify(formValues));
        tempData[index].invoice_number = e.target.value;
        setFormValues(tempData);
    }


    const handleInvoiceAmount = (e, item, index) => {
        // let re = /^[1-9][0-9]*$/;
        // let re = /^(?:\d*\.\d{1,2}|\d+)$/;
        let re = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/;
        if (re.test(e.target.value) || e.target.value == '') {
            let tempData = JSON.parse(JSON.stringify(formValues));
            tempData[index].invoice_amount = e.target.value;
            setFormValues(tempData);
        }
    }

    let addFormFields = () => {
        setFormValues([...formValues, { id: '', invoice_file_url: "", po_values: '', po_number: "", invoice_number: "", invoice_amount: "" }])
    }

    let removeFormFields = (i) => {
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues)
    }

    const [checkRequired, setCheckRequired] = useState(false);
    const handleSaveForm = () => {

        console.log(formValues);
        let notAllow = false;

        for (let i = 0; i < formValues.length; i++) {
            if (formValues[i].invoice_file_url == '' || formValues[i].po_number == '' || formValues[i].invoice_number == '' || formValues[i].invoice_amount == '') {
                notAllow = true
            }
        }

        if (notAllow == false) {
            setCheckRequired(false)
            let tempFormValues = formValues.map((item, i) => {
                return {
                    id: item.id.toString(),
                    invoice_file_url: item.invoice_file_url,
                    po_number: item.po_number.toString(),
                    invoice_number: item.invoice_number,
                    invoice_amount: parseFloat(item.invoice_amount),
                }
            })

            let payload = tempFormValues;

            console.log(payload);

            saveInvoiceCall.mutate(payload, {
                onSettled(data, error) {
                    if (data) {


                        let tmpPayload = {
                            msg: data.message,
                            status: true
                        }

                        dispatch({ type: 'BULK_UPDATE_FILE_UPLOAD', payload: tmpPayload })

                        history.push('/invoice-upload-listing')

                    } else if (error) {

                        let tmpPayload = {
                            msg: error.response.data.message,
                            status: false
                        }

                        dispatch({ type: 'BULK_UPDATE_FILE_UPLOAD', payload: tmpPayload })
                    }
                }
            });
        } else {
            setCheckRequired(true)
        }
    }

    const handleCancelForm = () => {
        history.push('/invoice-upload-listing')
    }
    return (<>

        <Content page="component">

            <BlockHead size="sm">
                <BlockBetween>
                    <BlockHeadContent>
                        <h6 className="title">Upload Invoices</h6>
                    </BlockHeadContent>
                </BlockBetween>
            </BlockHead>
            <Block>
                <div>
                    <table>
                        <thead className="">
                            <tr className="d-flex">
                                <th width="30%">Upload Invoice*</th>
                                <th width="23%">PO Number*</th>
                                <th width="23%">Invoice Number*</th>
                                <th width="23%">Invoice Amount*</th>
                                <th width="8%">
                                    {!isEdit && <button type="button" className="btn btn-sm btn-outline-success"
                                        onClick={addFormFields}
                                    >
                                        <Icon name="plus" />
                                    </button>

                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {formValues.map((element, index) => (
                                <tr className="d-flex">
                                    <td width="30%" className="table-block">
                                        <div className="form-control-wrap">
                                            <div className="custom-file" style={{ width: '85%' }}>
                                                <input
                                                    type="file"
                                                    className="custom-file-input"
                                                    id="invoice_file"
                                                    name="invoice_file"
                                                    onChange={(e) => handleFileSave(e, element, index)}
                                                    // accept="application/pdf,application/vnd.ms-excel"
                                                    accept=".doc,.docx,application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                // disabled={!isEdit}
                                                />
                                                <label className="custom-file-label" htmlFor="invoice_file">
                                                    {element.invoice_file_url == "" ? "Choose files" : element.invoice_file_url}
                                                </label>
                                            </div>
                                            {element.invoice_file_url != "" && <a href={element.invoice_file_url} target="_blank" className="file-downlod-ico"><Icon name="download" /></a>}
                                        </div>
                                        <div>
                                        </div>
                                        {checkRequired && element.invoice_file_url == '' ? <span className="error-text">This field is required.</span> : ''}
                                        {/* <span className={`mandatory-field-val ${element.invoice_file_url ? 'show-mandatory-field' : 'hide-mandatory-field'}`}>{element.invoice_file_url == '' ? '*Mandatory Field' : ''}</span> */}
                                    </td>

                                    <td width="23%" className="table-block">
                                        <div className="checkbox-selector">
                                            <ReactMultiSelectCheckboxes
                                                className="field-class"
                                                classNamePrefix="inner-field-class"
                                                options={poArray}
                                                placeholderButtonLabel="PO Number"
                                                value={element.po_values}
                                                onChange={(e) => handlePONumber(e, element, index)}
                                            />
                                        </div>
                                        {checkRequired && element.po_values == '' ? <span className="error-text">This field is required.</span> : ''}
                                    </td>

                                    <td width="23%" className="table-block">
                                        <input
                                            type="text"
                                            className="form-control"
                                            // placeholder="Phone" 
                                            // name="invoice_number" 
                                            value={element.invoice_number || ""}
                                            onChange={e => handleInvoiceChange(e, element, index)}
                                        // readOnly={isEditable ? false : true}                                     
                                        />
                                        {checkRequired && element.invoice_number == '' ? <span className="error-text">This field is required.</span> : ''}


                                        {/* <span className={`mandatory-field-val ${element.valid_phone_number == false ? 'show-mandatory-field' : 'hide-mandatory-field'}`}>*Mandatory Field</span> */}
                                    </td>
                                    <td width="23%" className="table-block">
                                        <input type="number" className="form-control"
                                            value={element.invoice_amount || ""}
                                            onChange={e => handleInvoiceAmount(e, element, index)}
                                        />
                                        {checkRequired && element.invoice_amount == '' ? <span className="error-text">This field is required.</span> : ''}
                                    </td>
                                    <td width="8%">
                                        {/* {formValues.length > 1 && */}
                                        <button
                                            className={formValues.length > 1 ? "show-remove-field btn btn-sm btn-outline-danger" : 'btn btn-sm btn-outline-danger hide-remove-field'}
                                            onClick={() => removeFormFields(index)}
                                        ><Icon name="trash" />
                                        </button>
                                        {/* } */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <button className="btn btn-sm btn-primary mt-2" onClick={handleSaveForm}
                    disabled={saveInvoiceCall.isLoading ? true : false}
                >
                    {saveInvoiceCall.isLoading ? <Spinner color="light" size='sm' /> : <Icon name="save" />} &nbsp; Save
                </button>

                <button className="btn btn-sm btn-white btn-outline-light mt-2 ml-2" onClick={handleCancelForm}
                >
                    <Icon name="cross" /> &nbsp; Cancel
                </button>

            </Block>
        </Content>
        <ToastContainer />
    </>)
};

export default InvoiceAdd;